<div class="login-container">
  <div class="login-card">
    <!-- Logo y título -->
    <div class="logo-container">
      <img src="assets/img/logo.png" alt="Logo">

    </div>

    <!-- Formulario -->
    <form #f="ngForm">
      <!-- Campo de usuario -->
      <div class="form-group">
        <label for="username">Usuario</label>
        <div class="input-group">
          <input [(ngModel)]="user" name="user" required class="form-control">
          <i class="icon fas fa-user"></i>
        </div>
      </div>

      <!-- Campo de contraseña -->
      <div class="form-group">
        <label for="password">Contraseña</label>
        <div class="input-group">
          <input [type]="showPass ? 'text' : 'password'" [(ngModel)]="pass" name="pass" required class="form-control">


          <!-- Usamos button type="button" para que NO haga submit -->
          <button type="button" class="eye-btn" aria-label="Mostrar contraseña" (click)="onTogglePass($event)"
            title="Mostrar / ocultar contraseña">
            <i class="fas" [ngClass]="showPass ? 'fa-eye-slash' : 'fa-eye'"></i>
          </button>

        </div>
      </div>




      <!-- Botón de login -->
      <button [disabled]="proccess" (click)="login()" class="btn-login">
        <ng-container *ngIf="proccess; else elseTemplate">
          Espere por favor ...
        </ng-container>
        <ng-template #elseTemplate>
          Iniciar Sesión
        </ng-template>

      </button>
    </form>
  </div>
</div>